/**
 * 异步加载并初始化性能监控模块
 * 不阻塞主 bundle，按需加载
 */
export async function loadPerformanceMonitor(): Promise<void> {
  try {
    const { initPerformanceMonitor } = await import('./helper');
    initPerformanceMonitor();
  } catch (error) {
    console.error('[Performance] Failed to load performance monitor:', error);
  }
}
